document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-seednary-header-menu]").forEach((header) => {
    const primaryButtons = header.querySelectorAll("[data-seednary-primary]");
    const panels = header.querySelectorAll("[data-seednary-panel]");
    const mega = header.querySelector("[data-seednary-mega]");

    primaryButtons.forEach((button) => {
      const activatePrimary = () => {
        const index = button.dataset.seednaryPrimary;
        primaryButtons.forEach((item) => item.classList.remove("is-active"));
        panels.forEach((panel) => panel.classList.toggle("is-active", panel.dataset.seednaryPanel === index));
        button.classList.add("is-active");
        mega?.classList.add("is-open");
        header.classList.add("is-mega-open");
      };

      button.addEventListener("mouseenter", activatePrimary);
    });

    header.querySelectorAll("[data-seednary-panel]").forEach((panel) => {
      const tabs = panel.querySelectorAll("[data-seednary-tab]");
      const contents = panel.querySelectorAll("[data-seednary-content]");

      tabs.forEach((tab) => {
        const activateTab = () => {
          const index = tab.dataset.seednaryTab;
          tabs.forEach((item) => item.classList.remove("is-active"));
          contents.forEach((content) => content.classList.toggle("is-active", content.dataset.seednaryContent === index));
          tab.classList.add("is-active");
        };

        tab.addEventListener("mouseenter", activateTab);
        tab.addEventListener("click", activateTab);
      });
    });

    header.querySelectorAll("[data-seednary-az-filter]").forEach((filter) => {
      const scope = filter.closest(".seednary-mega__content, .seednary-mobile-accordion__panel");
      const items = scope ? scope.querySelectorAll("[data-az-item]") : [];

      filter.querySelectorAll("[data-letter]").forEach((button) => {
        button.addEventListener("click", () => {
          const letter = button.dataset.letter;
          filter.querySelectorAll("[data-letter]").forEach((item) => item.classList.remove("is-active"));
          button.classList.add("is-active");

          items.forEach((item) => {
            item.hidden = letter !== "ALL" && item.dataset.letter !== letter;
          });
        });
      });
    });

    header.addEventListener("mouseleave", () => {
      mega?.classList.remove("is-open");
      header.classList.remove("is-mega-open");
    });

    header.querySelectorAll("[data-seednary-search]").forEach((searchForm) => {
      const searchInput = searchForm.querySelector("[data-seednary-search-input]");
      const searchResults = searchForm.querySelector("[data-seednary-search-results]");
      const searchRoot = (searchForm?.dataset.searchRoot || window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
      let searchTimer;
      let searchController;

      const closeSearchResults = () => {
        if (searchResults) {
          searchResults.hidden = true;
          searchResults.innerHTML = "";
        }
      };

      const renderSearchResults = (resources) => {
        const products = resources?.resources?.results?.products || resources?.results?.products || [];
        const collections = resources?.resources?.results?.collections || resources?.results?.collections || [];
        const items = [...products, ...collections].slice(0, 8);

        if (!searchResults) return;

        if (!items.length) {
          searchResults.innerHTML = '<div class="seednary-search-results__empty">No results found</div>';
          searchResults.hidden = false;
          return;
        }

        searchResults.innerHTML = `
          <div class="seednary-search-results__title">Search results</div>
          ${items
            .map((item) => {
              const image = item.image || item.featured_image || {};
              const imageUrl = typeof image === "string" ? image : image.url || image.src || "";
              const imageMarkup = imageUrl
                ? `<span class="seednary-search-result__image"><img src="${imageUrl}" alt="${item.title || ""}"></span>`
                : '<span class="seednary-search-result__image"></span>';
              const type = item.type || (item.price ? "Product" : "Collection");
              const url = item.url || item.handle || "#";
              return `
                <a class="seednary-search-result" href="${url}">
                  ${imageMarkup}
                  <span>
                    <strong>${item.title}</strong>
                    <span>${type}</span>
                  </span>
                </a>
              `;
            })
            .join("")}
        `;
        searchResults.hidden = false;
      };

      searchInput?.addEventListener("input", () => {
        const query = searchInput.value.trim();
        window.clearTimeout(searchTimer);

        if (query.length < 2) {
          closeSearchResults();
          return;
        }

        searchTimer = window.setTimeout(async () => {
          searchController?.abort();
          searchController = new AbortController();

          try {
            const response = await fetch(
              `${searchRoot}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor`,
              { signal: searchController.signal }
            );
            if (!response.ok) return;
            renderSearchResults(await response.json());
          } catch (error) {
            if (error.name !== "AbortError") closeSearchResults();
          }
        }, 180);
      });

      searchForm?.addEventListener("submit", () => {
        closeSearchResults();
      });

      document.addEventListener("click", (event) => {
        if (!searchForm?.contains(event.target)) closeSearchResults();
      });
    });

    if (header.dataset.stickyReveal === "true") {
      let lastScrollY = window.scrollY;

      window.addEventListener(
        "scroll",
        () => {
          const currentScrollY = window.scrollY;
          const isScrollingUp = currentScrollY < lastScrollY;

          if (currentScrollY < 120 || isScrollingUp) {
            header.classList.remove("is-scroll-hidden");
            header.classList.toggle("is-scroll-visible", currentScrollY > 120);
          } else {
            header.classList.add("is-scroll-hidden");
            header.classList.remove("is-scroll-visible");
            mega?.classList.remove("is-open");
            header.classList.remove("is-mega-open");
          }

          lastScrollY = currentScrollY;
        },
        { passive: true }
      );
    }
  });
});
